export default (v) => {
    if (!v) {
        return 0;
    }
    return new Intl.NumberFormat('es-AR').format(v);
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/decimales.js